export default {
  label: {
    title: 'Import file',
    file: 'File',
    insertFile: 'Select the file',
    cancel: 'Cancel',
    ok: 'Ok',
    send: 'Send',
    clear: 'Clear',
    requiredValue: 'Required value',
    queued: 'Queued',
    proccessed: 'Processed successfully',
    status: 'Status: ',
    totalPosts: 'Total Posts: ',
    dataStorageUrl: 'Processed spreadsheet link: ',
    errorMessage: 'Error description: ',
  },

  infoLabel: 'Form information',
  closeLabel: 'Close information',
  exportLinkText: 'Processed spreadsheet link',

  upload: {
    error: 'There are errors in the posts in the spreadsheet, please check the data and try again.',
    success: 'Document uploaded successfully',
  },

  faq: {
    title: 'What is the format of the spreadsheet?',
    description: 'The spreadsheet must be in .xlsx format and in the correct format for import.',
  },
  faq2: {
    title: 'What is the correct formatting for the spreadsheet?',
    description: 'Just follow the base spreadsheet sent when hiring the component.',
  },
  faq3: {
    title: 'How can I know if my data has been imported?',
    description: 'The imported data will appear in the Warroom, in the publication wall within the "Imported Data" channel.',
  },
  faq4: {
    title: 'What to do if the spreadsheet has errors?',
    description: 'The component will return a link to the spreadsheet with all the rows that had errors, informing them. It is possible to correct the errors in the returned spreadsheet and resend it for proper import.',
  },
};
